import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=ddf064b4&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=ts"
export * from "./TreeItem.vue?vue&type=script&lang=ts"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=ddf064b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf064b4",
  null
  
)

export default component.exports